import { defineComponent } from '@vue/composition-api';
import { GoodsOfferDecisionType as DecisionType, GoodsOfferDecisionStatus, } from '@/api/v2/requests/goods-offers';
import GoodsOfferAcceptItem from '../GoodsOfferAcceptItem/GoodsOfferAccptItem.vue';
const DECISION_LEVELS = [
    DecisionType.CENTRAL,
    DecisionType.STRUCTURE,
    DecisionType.PLACE,
];
export default defineComponent({
    name: 'GoodsOfferAccept',
    components: { GoodsOfferAcceptItem },
    props: {
        goodsOffer: {
            type: Object,
            required: true,
        },
        isReadOnly: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['refresh'],
    setup(props, ctx) {
        const decisionLevels = DECISION_LEVELS;
        function getLevelLabel(level) {
            return String(ctx.root.$t(`goods-offer.${level.toLowerCase()}`));
        }
        function getDecision(level) {
            // TODO change when GoodsOfferDto is updated to use correct type
            const offer = props.goodsOffer;
            if (!offer || !offer.decisions || !Array.isArray(offer.decisions)) {
                return null;
            }
            return offer.decisions.find((d) => d.type === level) || null;
        }
        function getOverallStatus() {
            const centralDecision = getDecision(DecisionType.CENTRAL);
            return centralDecision?.decision || null;
        }
        function getStatusColor(status) {
            switch (status) {
                case GoodsOfferDecisionStatus.ACCEPTED:
                    return 'bg-green-lightest text-green';
                case GoodsOfferDecisionStatus.REJECTED:
                    return 'bg-red-lightest text-red';
                case GoodsOfferDecisionStatus.REVERTED:
                    return 'bg-gray-lightest text-black';
                default:
                    return '';
            }
        }
        function handleRefresh() {
            ctx.emit('refresh');
        }
        return {
            decisionLevels,
            getLevelLabel,
            getOverallStatus,
            getStatusColor,
            handleRefresh,
        };
    },
});
